import CampaignsEditor from 'modules/Services/CampaignsEditor/CampaignsEditor'
import Reducer from 'modules/Services/CampaignsEditor/reducer'
import Sagas from 'modules/Services/CampaignsEditor/saga'

export default CampaignsEditor

export { Reducer, Sagas }
